
/* injects from baggage-loader */

'use strict';

export default class AccountSettingsSecurityController {

	constructor($log, Alerts, ServerEvent, Session, Parse) {
		'ngInject';

		this.$log = $log;
		this.ServerEvent = ServerEvent;
		this.Session = Session;
		this.Parse = Parse;

		// Title displayed on the simple form template
		this.formTitle = 'Security';

		// Assign alerts service
		this.alerts = Alerts;

		// Hold security object
		this.unsuccessfulAttempts = [];
		this.sessions = [];

	}

	$onInit() {

		// Setup the map options from data found in the current session
		if (this.currentSession.get('geoip') && typeof this.currentSession.get('geoip')['latitude'] === 'number' && typeof this.currentSession.get('geoip')['longitude'] === 'number') {
			this.mapOptions = {
				lat: this.currentSession.get('geoip')['latitude'],
				lng: this.currentSession.get('geoip')['longitude'],
				width: 300,
				height: 130
			};
		}

		// Get the some unsuccessful login ttempts
		this.ServerEvent.query('login-attempt', {
			equalTo: {
				key: 'success',
				value: false
			}
		}).then(results => {
			this.unsuccessfulAttempts = results;
		});

		// Query for sessions
		this.Session.query({
			notEqualTo: {
				key: 'sessionToken',
				value: this.Parse.User.current().getSessionToken()
			},
			exists: 'loginEvent'
		}).then(results => {
			this.sessions = results;
		});

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account/settings/security/account.settings.security.controller.js